import { Item } from "./components/item/item";
import { Base } from "./featureList.base";

export const FeatureList = Object.assign(Base, {
    Item: Item
});
